import * as React from 'react';
import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Translate from './Translate';
import DocumentDropDown from './DocumentDropDown';
import DocumentCheckboxButton from './DocumentCheckboxButton';
import Disclaimers from './Disclaimers';
import { DataStore } from '../stores/DataStore';

const DocumentModuleWrapper = styled<any, any>('div')`
    ${propStyles};
`;

DocumentModuleWrapper.defaultProps = {
    marginX: 'md',
};

const DocumentsHeading = styled<any, any>('h2')`
    ${propStyles};
`;

DocumentsHeading.defaultProps = {
    fontFamily: 'heading',
    fontWeight: 'medium',
    fontSize: 'sm',
    color: 'body',
};

const DocumentsList = styled<any, any>('ol')`
    ${propStyles};
    list-style: none;
`;

DocumentsList.defaultProps = {
    display: 'flex',
    flexDirection: 'column',
    marginY: 'md',
};

const DocumentsListItem = styled<any, any>('li')`
    ${propStyles};
    list-style: none;
`;

DocumentsListItem.defaultProps = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingY: 'sm',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'none none solid none',
};

const DocumentGroupName = styled<any, any>('h3')`
    ${propStyles};
`;

DocumentGroupName.defaultProps = {
    fontFamily: 'body',
    fontWeight: 'normal',
    fontSize: 'sm',
    color: 'body',
    margin: '0 1em 0 0',
};

interface DocumentModuleProps {
    theme?: any;
    dataStore?: DataStore;
}

@inject('dataStore')
@observer
class DocumentModule extends Component<DocumentModuleProps> {
    render() {
        const {
            theme,
            dataStore: { stores, documentModule },
        } = this.props;
        return documentModule && !stores.loading.global ? (
            <DocumentModuleWrapper {...theme.DocumentModuleWrapper}>
                <Disclaimers
                    disclaimers={documentModule.headerDisclaimers}
                    theme={{
                        ...theme,
                        DisclaimersList:
                            theme.DocumentModuleHeaderDisclaimersList,
                        DisclaimerListItem:
                            theme.DocumentModuleHeaderDisclaimerListItem,
                        DisclaimerContent:
                            theme.DocumentModuleHeaderDisclaimerContent,
                    }}
                />
                <DocumentsHeading {...theme.DocumentModuleHeading}>
                    <Translate>{documentModule.header.label}</Translate>
                </DocumentsHeading>
                {documentModule.groupedDocuments.length > 0 ? (
                    <DocumentsList {...theme.DocumentModuleList}>
                        {documentModule.groupedDocuments.map((d, index) => (
                            <DocumentsListItem
                                key={d.documentGroupName}
                                {...theme.DocumentModuleListItem}
                            >
                                <DocumentGroupName
                                    {...theme.DocumentModuleGroupName}
                                >
                                    {d.documentGroupName}
                                </DocumentGroupName>
                                {d.documents.length > 1 ? (
                                    <DocumentDropDown
                                        documents={d.documents}
                                        theme={{
                                            ...theme,
                                            DocumentDropdownIcon: {
                                                margin: '0 0 0 0.5em',
                                            },
                                            DownloadControls:
                                                theme.DocumentModuleDownloadControls,
                                            DownloadButton:
                                                theme.DocumentModuleDownloadButton,
                                            DownloadButtonIcon: {
                                                marginX: '0',
                                                margin: '0 0 0 0.5em',
                                                ...theme.DocumentModuleDownloadButtonIcon,
                                            },
                                        }}
                                    >
                                        <Translate
                                            placeholders={{
                                                total: d.documents.length,
                                            }}
                                        >
                                            {`{total} Documents`}
                                        </Translate>
                                    </DocumentDropDown>
                                ) : (
                                    <DocumentCheckboxButton
                                        document={d.documents[0]}
                                        showCount={false}
                                        showCheckbox={false}
                                        borderStyle="none"
                                        hover={{
                                            bgColor: 'transparent',
                                        }}
                                        theme={{
                                            ...theme,
                                            DownloadControls:
                                                theme.DocumentModuleDownloadControls,
                                            DownloadButton:
                                                theme.DocumentModuleDownloadButton,
                                            DownloadButtonIcon: {
                                                marginX: '0',
                                                margin: '0 0 0 0.5em',
                                                ...theme.DocumentModuleDownloadButtonIcon,
                                            },
                                        }}
                                    />
                                )}
                            </DocumentsListItem>
                        ))}
                    </DocumentsList>
                ) : (
                    <Disclaimers
                        disclaimers={documentModule.noDataDisclaimers}
                        theme={{
                            ...theme,
                            DisclaimersList:
                                theme.DocumentModuleNoDataDisclaimersList,
                            DisclaimerListItem:
                                theme.DocumentModuleNoDataDisclaimerListItem,
                            DisclaimerContent:
                                theme.DocumentModuleNoDataDisclaimerContent,
                        }}
                    />
                )}
                <Disclaimers
                    disclaimers={documentModule.footerDisclaimers}
                    theme={{
                        ...theme,
                        DisclaimersList:
                            theme.DocumentModuleFooterDisclaimersList,
                        DisclaimerListItem:
                            theme.DocumentModuleFooterDisclaimerListItem,
                        DisclaimerContent:
                            theme.DocumentModuleFooterDisclaimerContent,
                    }}
                />
            </DocumentModuleWrapper>
        ) : null;
    }
}

export default withTheme(DocumentModule);



// WEBPACK FOOTER //
// ./src/Components/DocumentModule.tsx